import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=4334bc2c&scoped=true"
import script from "./NotificationHandler.vue?vue&type=script&lang=ts"
export * from "./NotificationHandler.vue?vue&type=script&lang=ts"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=4334bc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334bc2c",
  null
  
)

export default component.exports